module.exports = __webpack_public_path__ + "img/modelo-en2.1b558722.png";